const generateFacebookShareLink = (urlToShare) =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;

export default generateFacebookShareLink;
